module.exports = __webpack_public_path__ + "img/fondo.5799ff37.png";